import React from 'react';

const TommorowFocusContent = () => {
  return <h2>TommorowFocusContent</h2>;
};

export default TommorowFocusContent;
